import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return [];
  }


  initialize(){

  }

 
   
   onSubmitFail(e){
    let elem = document.createElement('div');
    elem.innerHTML = e.detail[2].response;
    this.element.replaceWith(elem.firstChild); 
  }




}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/tab_controller.js